angular.module("staff_positions")

    .controller("StaffPositionsEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate','modalService', '$uibModal',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal) {
          
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("STAFF_POSITION_WRITE");

        $rootScope.title = $filter('translate')('staff_positions.title');

        $scope.staff_position = {
        };
        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('staff_positions.title'), url: "staff_positions.list" },
                { title: $filter('translate')('staff_positions.title_add')},
            ];
            
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('staff_positions.title'), url: "staff_positions.list" },
                { title: $filter('translate')('staff_positions.title_edit')},
            ];

            Restangular.one('StaffPositions', $stateParams.id).get().then(function (result) {
               
                $scope.staff_position = result;
            });
        }               
                                       
        $scope.saveStaffPosition = function () {            
            if (angular.isDefined($scope.id)) {
                $scope.staff_position.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('staff_positions.save_success'));
                        $state.go("staff_positions.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('StaffPositions').post($scope.staff_position).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('staff_positions.edit_success'));
                        $state.go("staff_positions.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('staff_positions.button_delete'),
                message: $filter('translate')('staff_positions.delete_message') + " " + $scope.staff_position.name + "?",
                onAccept: function () {
                    $scope.staff_position.remove().then(function () {
                        toastr.success($filter('translate')('staff_positions.deleted_success'));
                        $state.go("staff_positions.list");
                    });
                }
            });
        };        

}])

;

